import React, { useState, Suspense } from "react"
import { Routes, Route } from "react-router-dom"
import Sidebar               from "./components/Sidebar"
import Login                 from "./pages/Login"
import "./styles.css"

const Dashboard             = React.lazy(() => import("./pages/Dashboard"))
const Clientes              = React.lazy(() => import("./pages/Clientes"))
const Venta                 = React.lazy(() => import("./pages/Venta"))
const Agenda                = React.lazy(() => import("./pages/Agenda"))
const Estilistas            = React.lazy(() => import("./pages/Estilistas"))
const Servicios             = React.lazy(() => import("./pages/Servicios"))
const Gastos                = React.lazy(() => import("./pages/Gastos"))
const Inventario            = React.lazy(() => import("./pages/Inventario"))
const MovimientosInventario = React.lazy(() => import("./pages/MovimientosInventario"))
const Reportes              = React.lazy(() => import("./pages/Reportes"))
const AgendaVista           = React.lazy(() => import("./pages/AgendaVista"))
const DashboardComparativos = React.lazy(() => import("./pages/DashboardComparativos"))

const SIDEBAR_WIDTH = 240

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"))

  if (!token) {
    return <Login setToken={setToken} />
  }

  return (
    <div>
      <Sidebar setToken={setToken} />
      <div style={{ marginLeft: SIDEBAR_WIDTH, padding: "24px", minHeight: "100dvh" }}>
        <Suspense fallback={<div className="loading">Cargando pantalla...</div>}>
          <Routes>
            <Route path="/"                        element={<Dashboard />} />
            <Route path="/ventas"                  element={<Venta />} />
            <Route path="/agenda"                  element={<Agenda />} />
            <Route path="/agenda-vista"            element={<AgendaVista />} />
            <Route path="/clientes"                element={<Clientes />} />
            <Route path="/estilistas"              element={<Estilistas />} />
            <Route path="/servicios"               element={<Servicios />} />
            <Route path="/gastos"                  element={<Gastos />} />
            <Route path="/inventario"              element={<Inventario />} />
            <Route path="/movimientos-inventario"  element={<MovimientosInventario />} />
            <Route path="/reportes"                element={<Reportes />} />
            <Route path="/dashboard-comparativos"  element={<DashboardComparativos />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}

export default App
